module.exports = __webpack_public_path__ + "static/media/team.bd252cfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/team.svg
// module id = 286
// module chunks = 0